export enum JobTypeNameEnum {
    FullTime = "Full-time",
    PartTime = "Part-time",
    Contract = "Contract",
    Locum = "Locum",
}

export enum JobTypeIdEnum {
    FullTime = 1,
    PartTime = 2,
    Contract = 4,
    Locum = 7,
}
